import { render, staticRenderFns } from "./PowerupHierarchy.vue?vue&type=template&id=78b6ae71&scoped=true"
import script from "./PowerupHierarchy.vue?vue&type=script&lang=js"
export * from "./PowerupHierarchy.vue?vue&type=script&lang=js"
import style0 from "./PowerupHierarchy.vue?vue&type=style&index=0&id=78b6ae71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6ae71",
  null
  
)

export default component.exports